import {css} from '@genesislcap/web-core';
import {mixinScreen, closeIconStyles} from '../../styles';

export const HelpDialogStyles = css`
  :host {
    ${mixinScreen('flex')}
  }
  
  #content-text {
    margin: 0px 10px;
    max-width: 550px;
  }
  
  #title {
    margin-left: 10px;
  }

  ${closeIconStyles}

  p a {
    color: var(--accent-foreground-rest);
  }

  .p-description {
    margin: 16px 0px;
  }
  
  .hide {
    display:none;
  }
`;
